<script lang="ts" setup>
import {FormKitIcon} from '@formkit/vue'

interface LogoProps {
  variant?: "default" | "white";
  path?: string;
  to?: string;
}

const {variant = 'default',path,to = '/'} = defineProps<LogoProps>();
const localePath = useLocalePath();

</script>

<template>
  <NuxtLink
    :to="localePath(to)"
    class="logo"
  >
    <FormKitIcon
      v-if="!path"
      :icon="`logo_${variant}`"
    />
    <NuxtImg
      v-else
      :src="path"
    />
  </NuxtLink>
</template>


<style lang="scss" scoped>
.logo {
  flex-shrink: 0;
  img {
    max-height: 50px;
    width: auto;
  }

  .formkit-icon {
    :deep(svg) {
      @media only screen and (max-width: $tablet) {
        max-height: 30px;
      }
    }
  }
}
</style>
